import { render, staticRenderFns } from "./BViewTemplate.vue?vue&type=template&id=274e38c3&scoped=true"
import script from "./BViewTemplate.vue?vue&type=script&lang=js"
export * from "./BViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./BViewTemplate.vue?vue&type=style&index=0&id=274e38c3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e38c3",
  null
  
)

export default component.exports